<template>
  <!--
    v-html aquí es seguro: `markup` viene únicamente de ./paths.js, datos SVG
    estáticos incluidos en el propio código fuente (no hay entrada de usuario
    ni contenido remoto involucrado).
  -->
  <svg
    class="ph-icon"
    viewBox="0 0 256 256"
    fill="currentColor"
    aria-hidden="true"
    v-html="markup"
  ></svg>
</template>

<script>
import { iconPaths } from './paths'

export default {
  name: 'PhIcon',
  props: {
    name: {
      type: String,
      required: true
    },
    // 'regular' (trazo) o 'fill' (relleno, para el estado activo)
    weight: {
      type: String,
      default: 'regular'
    }
  },
  computed: {
    markup () {
      const icon = iconPaths[this.name]
      if (!icon) {
        console.warn(`[PhIcon] icono desconocido: "${this.name}"`)
        return ''
      }
      return icon[this.weight] || icon.regular
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/icons/PhIcon.vue